<template>
  <el-dialog
      v-model="dialogVisible"
      title="新增禁书"
      width="420px"
      :before-close="handleClose"
  >
    <div class="main-container">
      <div class="row flex a-c">
        <div class="row-tip"><i class="iconfont unify-bitian"></i>ISBN:</div>
        <el-input style="width: 260px" v-model="state.isbn" placeholder="请输入禁书 ISBN" clearable />
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="confirmHandler">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import {reactive, ref} from 'vue'
import {addSchoolResourceIsbnFilter} from "@/js/network/main/index"
import {MessageBox} from "@/js/utils/commonJs";

export default {
  setup(props, {emit}) {
    const state = reactive({
      isbn: "",
    })
    const dialogVisible = ref(false)
    const confirmLoading = ref(false)

    // 关闭并清空
    const handleClose = () => {
      state.isbn = "";
      dialogVisible.value = false;
    }

    // 打开弹窗
    const init = () => {
      state.isbn = "";
      dialogVisible.value = true;
    }

    // 确认新增
    const confirmHandler = () => {
      if (!state.isbn || !state.isbn.trim()) {
        MessageBox.error('ISBN必填');
        return;
      }
      confirmLoading.value = true;
      addSchoolResourceIsbnFilter({isbn: state.isbn.trim()}).then(res => {
        confirmLoading.value = false;
        if (!res || !res.success) {
          MessageBox.error(res?.msg || '新增失败');
          return;
        }
        dialogVisible.value = false;
        MessageBox.success(res.msg || '添加成功!');
        emit("success");
      }).catch(error => {
        confirmLoading.value = false;
        console.log(error, "catchError");
      });
    }

    return {
      state,
      dialogVisible,
      confirmLoading,
      handleClose,
      init,
      confirmHandler,
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-footer button:first-child {
  margin-right: 10px;
}

.main-container {
  .row {
    margin-bottom: 16px;
  }

  .row-tip {
    width: 80px;
    color: #6573A2;
    flex-shrink: 0;

    .iconfont {
      color: #f56c6c;
      margin-right: 2px;
      font-size: 12px;
    }
  }
}
</style>
